<div class="carousel"  [attr.id]="componentId">
    <div #carouselContainer class="carousel-container"  [ngStyle]="{'transform': carouselTransform}">
      <!-- Solo mostramos las tarjetas visibles en el rango determinado -->
      <div *ngFor="let item of cards" class="carousel-cell" [ngClass]="(isDesktop)?'desk' : 'mob'">
        <div [id]="(isDesktop) ? 'mes-d'+item.id : 'mes-m'+item.id">
            <a href="{{language}}/calendario/{{item.id}}/{{year}}{{linkVenue}}"
                class=" pointer pb-5 ">
                <h3 class="fs-16 c-principal bold">{{item.name}}</h3>
            </a>
        </div>
      </div>
  
  
    </div>
    <!-- Flechas de navegación solo se muestran si hay más tarjetas -->
    <div class="arrows" *ngIf="cards.length > cant">
      <!-- Flecha izquierda -->
      <button [ngClass]="{'locked': lockedLeft}" (click)="moveLeft()" [disabled]="lockedLeft">
        <img class="arrow-carrousel" src="./assets/img/arrow-carrousel-left.svg" alt="Left Arrow">
      </button>
  
      <!-- Flecha derecha -->
      <button [ngClass]="{'locked': lockedRight}" (click)="moveRight()" [disabled]="lockedRight">
        <img class="arrow-carrousel" src="./assets/img/arrow-carrousel-right.svg" alt="Right Arrow">
      </button>
    </div>
  </div>